package com.schoolconnect.app.designsystem

import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.layout.widthIn
import androidx.compose.ui.Alignment
import androidx.compose.material3.SnackbarHost
import androidx.compose.material3.SnackbarHostState
import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.remember
import androidx.compose.ui.Modifier
import androidx.compose.ui.unit.dp
import ischoolconnect.sharedui.generated.resources.Res
import ischoolconnect.sharedui.generated.resources.check_circle_filled
import kotlinx.coroutines.flow.asSharedFlow

data class AppToastEvent(val message: String)

object AppToastCenter {
    private val _successEvents = kotlinx.coroutines.flow.MutableSharedFlow<AppToastEvent>(extraBufferCapacity = 32)
    val successEvents = _successEvents.asSharedFlow()

    fun showSuccess(message: String) {
        val normalized = message.trim()
        if (normalized.isNotBlank()) _successEvents.tryEmit(AppToastEvent(normalized))
    }
}

@Composable
fun AppSuccessToastHost(
    modifier: Modifier = Modifier,
    hostState: SnackbarHostState = remember { SnackbarHostState() }
) {
    LaunchedEffect(hostState) {
        AppToastCenter.successEvents.collect { event ->
            hostState.showSnackbar(event.message)
        }
    }

    SnackbarHost(
        hostState = hostState,
        modifier = modifier
            .fillMaxWidth()
            .padding(bottom = 16.dp)
    ) { snackbarData ->
        Box(
            modifier = Modifier.fillMaxWidth(),
            contentAlignment = Alignment.Center
        ) {
            AppSnackbar(
                message = snackbarData.visuals.message,
                modifier = Modifier.widthIn(min = 280.dp, max = 480.dp),
                accentColor = AppSuccess,
                containerColor = AppSuccessSoft,
                contentColor = AppNavy,
                borderColor = AppSuccessBorder,
                icon = Res.drawable.check_circle_filled
            )
        }
    }
}
